import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import Tip from "./Tip";

const Accordion = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const accordionRef = useRef(null);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  const handleOutsideClick = (event) => {
    event.preventDefault()
    if (accordionRef.current && !accordionRef.current.contains(event.target)) {
      setIsExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div className="accordion-inline" ref={accordionRef}>
      <Tip text="Auto Refresh Timer">
        <div
          className={`accordion-inline-header ${isExpanded ? "expanded" : ""} cursor-pointer`}
          onClick={toggleAccordion}
        >
          {title}
        </div>
      </Tip>
      {isExpanded && (
        <div
          className={`accordion-inline-content ${
            isExpanded ? "height-full" : "height-none"
          }`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AccordionCommon.jsx